import Grading from "../../Pages/Grading";



const navigation = {
    header: "Grading",
    links: [
      {
        text: "Grading",
        icon: <></>,
        route: "",
        component: Grading,
      },
    ],
  };
export default navigation;
